export { default } from "./GameResultPage"
